/*
 *  Featured Products
 *    Superclass for any carousel section you build, provides nice defaults that
 *    can be provided as data attributes from the wrapped container.
 *
 *  Version:
 *    1.0.0 - 2019/11/18
 */

import $ from 'jquery';
import 'slick-carousel';

import { CarouselSection } from './../carousel/CarouselSection';
import { register } from './../ShopifySection';
import * as ResponsiveSizes from './../../settings/Responsive';

export const CONTAINER_SELECTOR = '[data-featured-reviews]';
export const CAROUSEL_SELECTOR = '[data-featured-reviews-carousel]';
export const CAROUSEL_BUTTON_PREV = '[data-arrow-prev]';
export const CAROUSEL_BUTTON_NEXT = '[data-arrow-next]';
export const CAROUSEL_PAGE = '[data-case-steps-page]';

export class FeaturedReviews extends CarouselSection {
  constructor(container) {
    super(container);

    this.prevButton = container.find(CAROUSEL_BUTTON_PREV);
    this.nextButton = container.find(CAROUSEL_BUTTON_NEXT);

    this.stepPage = this.container.find(CAROUSEL_PAGE);

    
    // carousel
    this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    this.slick = this.initCarousel(this.carouselContainer);

        // On after slide change
        container.on('afterChange', (e, slick, currentSlide, nextSlide) => this.onSlickChange(e, slick, currentSlide, nextSlide));
  }

  onSlickChange(event, slick, currentSlide, nextSlide){
    let current = slick.currentSlide+1;

    let body = `<span class="slick-page-wrap"><span class="slick-page">${current}</span><span class="c-featured-reviews__header-paginate-text">of</span><span class="slick-page">${slick.slideCount}</span></span>`
    this.stepPage.html(body);
  }

  optionOverrides() {
    return {
      infinite: this.carouselContainer.data('infinite') == false ? false : true,
      slidesToShow: this.carouselContainer.data('slides-to-show') || 1,
      slidesToScroll: this.carouselContainer.data('slides-to-scroll') || 1,
      autoplay: this.carouselContainer.data('autoplay') == false ? false : true,
      dots: this.carouselContainer.data('dots') == false ? false : true,
      arrows: true,
      adaptiveHeight: this.carouselContainer.data('adaptiveheight') == false ? false : true,
      autoplaySpeed: this.carouselContainer.data('autoplay-speed') || 5000,
      prevArrow: this.prevButton,
      nextArrow: this.nextButton,
      responsive: [
        {
          breakpoint: ResponsiveSizes.xsmall-1,
          settings: { slidesToShow: 1, slidesToScroll: 1 }
        },
        {
          breakpoint: 600,
          settings: { slidesToShow: 2, slidesToScroll: 2 }
        },
        {
          breakpoint: ResponsiveSizes.small-1,
          settings: { slidesToShow: 2, slidesToScroll: 2 }
        },
        {
          breakpoint: 900,
          settings: { slidesToShow: 3, slidesToScroll: 3 }
        },
        {
          breakpoint: ResponsiveSizes.medium-1,
          settings: { slidesToShow: 2, slidesToScroll: 2,
            arrows: this.carouselContainer.data('arrows') == false ? false : true,
            dots: false
          }
        },
        {
          breakpoint: ResponsiveSizes.large-1,
          settings: { slidesToShow: 3, slidesToScroll: 3,
            arrows: this.carouselContainer.data('arrows') == false ? false : true,
            dots: false
          }
        }
      ]
    }
  }

}

register(CONTAINER_SELECTOR, FeaturedReviews);